import React from 'react'
import { formatBigMoney } from '../../packages/utils/numberFormatters'
import { WarrantEntity } from '../../types/WarrantEntity'
import { getAmountForPriceAtDate, findSubscriptionPeriodCloseToDate } from '../../utils/warrants'

const sumSubscriptionPeriodsSharesSubscribed = (
    subscriptionPeriods: WarrantAmountProps['warrant']['subscriptionPeriods'],
) => {
    const sumSharesSubscribed = subscriptionPeriods?.reduce((acc, period) => {
        return acc + (period.sharesSubscribed ?? 0)
    }, 0)

    const hasNullValue = subscriptionPeriods?.some((period) => period.sharesSubscribed === null) || true

    return hasNullValue ? 0 : sumSharesSubscribed
}

interface WarrantAmountProps {
    locale: string
    warrant: WarrantEntity
}

function WarrantAmount({ warrant, locale }: WarrantAmountProps) {
    if (!warrant || warrant.totalNumberOfWarrants === null) return '-'

    const nowIso = new Date().toISOString()
    const currentPeriod = findSubscriptionPeriodCloseToDate(warrant, nowIso)

    if (!currentPeriod) return '-'

    const { totalNumberOfWarrants, subscriptionPeriods } = warrant
    const { priceMax, prelSubPrice, warrantSubPrice } = currentPeriod

    const formatSimpleMoney = (amount: number | null) =>
        formatBigMoney(amount, { locale, currencySymbol: warrant.currency }) || '-'
    const getSimpleAmount = (price: string | number | null) =>
        getAmountForPriceAtDate(price, totalNumberOfWarrants, subscriptionPeriods, nowIso)

    if (currentPeriod.warrantSubPrice !== null) {
        return formatSimpleMoney(getSimpleAmount(warrantSubPrice))
    } else if (prelSubPrice !== null) {
        const maxAmount = formatSimpleMoney(getSimpleAmount(priceMax))
        const prelAmount = formatSimpleMoney(getSimpleAmount(prelSubPrice))

        return (
            <>
                Prel: {prelAmount}
                <br />
                Max: {maxAmount}
            </>
        )
    }

    return '-'
}

export { WarrantAmount, sumSubscriptionPeriodsSharesSubscribed }
